export default __webpack_public_path__ + "static/media/icon-voucher.d9a67ad4.svg";